﻿export class FileUploadError {
    static eventName() { return 'FileUploadError'; }
    eventName = FileUploadError.eventName;

    constructor(public transferId: string) { }
}